function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddOnSuccess = function SvgIconAddOnSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 386.6,
    style: {
      fill: "#d70b17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.3 556.9 98.5 102.5 261.4-253.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 90,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgIconAddOnSuccess;